import React, { useEffect, useState } from 'react';

import './styles.css';
import Popup from '../../../../../components/Popup';
import {FaFilter} from 'react-icons/fa';
import Input from '../../../../../components/Input';
import billServices from '../../../../../services/admFin/billServices';
import bankAccountServices from '../../../../../services/admFin/bankAccountServices';

export default function FilterBankAccountTransfersPopUp(props) {
    const [bankAccounts, setBankAccounts] = useState([]);

    const [filterFields, setFilterFields] = useState({
        conta_origem: "",
        conta_destino: "",
        data: "",
        valor: "",
    });

    async function readBankAccounts() {
        const response = await bankAccountServices.getBankAccounts();
        if (response.status === 200) {
            setBankAccounts(response.data);
        } else
            alert("Erro ao ler informações auxiliares, tente novamente!");
    }
    

    useEffect(() => {
        readBankAccounts();
    }, []);

    useEffect(() => {
        if(props.bankAccountTransfers.length > 0)
            onFilter();
    }, [props.bankAccountTransfers]);


    function onFilter() {
        let auxArray = [...props.bankAccountTransfers];
        if(filterFields.conta_origem !== "") {
            const conta_origem_id = Number(filterFields.conta_origem.split(":")[0]);
            auxArray = auxArray.filter(obj =>  obj.conta_origem.id === conta_origem_id);
        }
        if(filterFields.conta_destino !== "") {
            const conta_destino_id = Number(filterFields.conta_destino.split(":")[0]);
            auxArray = auxArray.filter(obj =>  obj.conta_destino.id === conta_destino_id);
        }



        if(filterFields.data !== "") {
            auxArray = auxArray.filter(obj => obj.data === filterFields.data);
        }

        if(filterFields.valor !== "") {
            auxArray = auxArray.filter(obj => obj.valor === filterFields.valor);
        }


        props.setBankAccountTransfers(auxArray);
    }

    function onResetFilters() {
        setFilterFields({
            conta_origem: "",
            conta_destino: "",
            data: "",
            valor: "",
        });
    }

    function isReseted() {
        for(const key of Object.keys(filterFields)) {
            if( filterFields[key])
                return false;
        }
        return true;
    }


    return (
        <Popup
        visibility={props.visibility}
        setVisibility={props.setVisibility}
        tittle="Filtrar"
        icon={<FaFilter/>}
        >
            <div className='bills-filter-container'>
                <Input
                label="Conta Bancária Origem"
                type="select"
                id="bank-account-transfers-filter-bank-account-origin"
                options={bankAccounts.map(bankAccount => (`${bankAccount.id}: ${bankAccountServices.formatBankAccount(bankAccount)}`))}
                onChange={(e) => setFilterFields({...filterFields, conta_origem: e.target.value})}
                cleanValue=""
                value={filterFields.conta_origem}
                />
                <Input
                label="Conta Bancária Destino"
                type="select"
                id="bank-account-transfers-filter-bank-account-destiny"
                options={bankAccounts.map(bankAccount => (`${bankAccount.id}: ${bankAccountServices.formatBankAccount(bankAccount)}`))}
                onChange={(e) => setFilterFields({...filterFields, conta_destino: e.target.value})}
                cleanValue=""
                value={filterFields.conta_destino}
                />

                <Input
                label="Data"
                type="date"
                id="bank-account-transfers-filter-date"
                onChange={(e) => setFilterFields({...filterFields, data: e.target.value})}
                value={filterFields.data}
                />

                <Input
                    label="Valor"
                    type="currency"
                    id='bank-account-transfers-filter-value'
                    onChange={(e) => setFilterFields({...filterFields, valor: e.target.value})}
                    value={filterFields.valor}
                />


            </div>
            <button className="blue" onClick={() => {onFilter(); props.setVisibility(false)}}>
                Filtrar
            </button>

            {
                !isReseted() ?
                <button className="red" onClick={() => {onResetFilters()}}>
                    Resetar Filtros
                </button>
                :
                null
            }

        </Popup>

    )

}